// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"24064317","123":"cdec7b0f","424":"0c9ca91e","923":"e5151ad8","950":"93111286","982":"1a549c0e"}[chunkId] + ".chunk.js";
};